import type { MeetingMode } from "../lib/api.ts";

interface MeetingBadgeProps {
  mode: MeetingMode;
  className?: string;
}

const MODE_CONFIG: Record<MeetingMode, { icon: string; label: string; colors: string }> = {
  in_person: {
    icon: "📍",
    label: "In-person",
    colors: "bg-amber-50 text-amber-700 border-amber-200",
  },
  video: {
    icon: "📹",
    label: "Video call",
    colors: "bg-green-50 text-green-700 border-green-200",
  },
  phone: {
    icon: "📞",
    label: "Phone call",
    colors: "bg-blue-50 text-blue-700 border-blue-200",
  },
};

export function MeetingBadge({ mode, className = "" }: MeetingBadgeProps) {
  const config = MODE_CONFIG[mode];
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-xs font-medium ${config.colors} ${className}`}
    >
      <span aria-hidden="true">{config.icon}</span>
      {config.label}
    </span>
  );
}
